import axios from 'axios';

export default axios.create({
  baseURL: `https://luckydraw.ae/api/tvx/`,//YOUR_API_URL HERE
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  }
});
